import { render } from "./JoinPopup.vue?vue&type=template&id=c1b1f080&scoped=true"
import script from "./JoinPopup.vue?vue&type=script&lang=js"
export * from "./JoinPopup.vue?vue&type=script&lang=js"

import "./JoinPopup.vue?vue&type=style&index=0&id=c1b1f080&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ydsk-ph-h5-bankv3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1b1f080"]])

export default __exports__